export default __webpack_public_path__ + "c41826d8f7b327f79c45511cd980b9eb.png";